export default __webpack_public_path__ + "static/media/milk_col.002109f7.jpg";